export default __webpack_public_path__ + "static/media/peary-crossing-guard.1368a6b0.png";